export default "/assets/images/the-overreactor.64b58414d0acad64.jpg";